export default __webpack_public_path__ + "281b685785ed2fc9b30946e2ce49aff9.png";